import { getAssetURL } from "@/helpers/getAssetURL"

export const state = {
    data: {
        banner: {
            login: null,
            sidebarMinimize: null,
            sidebarMaximize: null,
            popup: null,
            popupLink: null
        },
        primaryLogo: {
            login: null
        },
        secondaryLogo: {
            sidebarMinimize: null
        },
        bannerDirect: {
            general: null
        },
        copyrightLogo: {
            general: null
        },
        tabTitle: {
            general: ''
        },
        facebook: {
            contactUs: null
        },
        instagram: {
            contactUs: null
        },
        linkedIn: {
            contactUs: null
        },
        youtube: {
            contactUs: null
        },
        whatsapp: {
            contactUs: null
        },
        companyName: {
            contactUs: null
        },
        headOffice: {
            contactUs: null
        },
        headOfficePhone: {
            contactUs: null
        },
        headOfficeHandphone: {
            contactUs: null
        },
        operationalOffice: {
            contactUs: null
        },
        operationalHandphone: {
            contactUs: null
        },
        favicon: {
            general: null
        }
    }
}

export const getters = {
    getAsset: (state) => (assetType, module) => {
        if (state.data?.[assetType] && state.data[assetType]?.[module] !== undefined) {
            return state.data[assetType][module];
        } else {
            return null;
        }
    }
}

export const mutations = {
    setAsset(state, {assetType, module, value}) {
        if (assetType == 'bannerDirect') {
            if (value != null && value != '' && !value.includes('https')) {
                value = 'https://' + value
            }
        }
        if (state.data?.[assetType] && state.data[assetType]?.[module] !== undefined) {
            state.data[assetType][module] = value
        }
    }
}

export const actions = {
    async fillAssetsURL(context) {
        const promisesAll = []
        for (const [assetType] of Object.entries(context.state.data)) {
            for (const [module] of Object.entries(context.state.data[assetType])) {
                promisesAll.push(getAssetURL(assetType, module))
            }
        }
        await Promise.all(promisesAll).then((result) => {
            for (const assetUrl of result) {
                context.commit('setAsset', assetUrl)
            }
        });
    }
}